import { TrayShapeId } from '@core/constants/Shape';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import {
    IFormFieldDimensionDefaultValueKey,
    IFormInputType,
    IDimensionUnit,
    IFormFieldShapeDimension,
} from '../../../interfaces/Form';

export const tableTrayShapeDimension: IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            TrayShapeId.TraysSquare,
            TrayShapeId.TrayRectangle,
            TrayShapeId.TrayRound,
            TrayShapeId.TrayOval,
        ],
        required: true,
    },
    dimension: {
        options: {
            [TrayShapeId.TraysSquare]: {
                [FieldDimensionId.Width]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 4000 },
                    required      : true,
                    defaultValue  : 900,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardWidth, 900],
                    ],
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 100 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
            [TrayShapeId.TrayRectangle]: {
                [FieldDimensionId.Length]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 6000 },
                    required      : true,
                    defaultValue  : 2000,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardLength, 2000],
                    ],
                },
                [FieldDimensionId.Width]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 4000 },
                    required      : true,
                    defaultValue  : 900,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardWidth, 900],
                    ],
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 100 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
            [TrayShapeId.TrayRound]: {
                [FieldDimensionId.Diameter]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 4000 },
                    required      : true,
                    defaultValue  : 900,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardDiameter, 900],
                    ],
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 100 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
            [TrayShapeId.TrayOval]: {
                [FieldDimensionId.Length]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 6000 },
                    required      : true,
                    defaultValue  : 2000,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardLength, 2000],
                    ],
                },
                [FieldDimensionId.Width]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 4000 },
                    required      : true,
                    defaultValue  : 900,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardWidth, 900],
                    ],
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 100 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
        },
    },
};

export const tableRectangleTrayShapeDimension: IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            TrayShapeId.TraysSquare,
            TrayShapeId.TrayRectangle,
        ],
        required: true,
    },
    dimension: {
        options: {
            [TrayShapeId.TraysSquare]: {
                [FieldDimensionId.Width]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 4000 },
                    required      : true,
                    defaultValue  : 900,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardWidth, 900],
                    ],
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 100 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
            [TrayShapeId.TrayRectangle]: {
                [FieldDimensionId.Length]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 6000 },
                    required      : true,
                    defaultValue  : 2000,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardLength, 2000],
                    ],
                },
                [FieldDimensionId.Width]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 4000 },
                    required      : true,
                    defaultValue  : 900,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardWidth, 900],
                    ],
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 100 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
        },
    },
};

export const trayDeskShapeDimension: IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            TrayShapeId.TraysSquare,
            TrayShapeId.TrayRectangle,
            TrayShapeId.TrayRound,
            TrayShapeId.TrayOval,
            TrayShapeId.ReturnLeft,
            TrayShapeId.ReturnRight,
        ],
        required: true,
    },
    dimension: {
        options: {
            [TrayShapeId.TraysSquare]: {
                [FieldDimensionId.Width]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 6000 },
                    required      : true,
                    defaultValue  : 1200,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardLength, 1200],
                    ],
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 100 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
            [TrayShapeId.TrayRectangle]: {
                [FieldDimensionId.Length]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 6000 },
                    required      : true,
                    defaultValue  : 1200,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardLength, 1200],
                    ],
                },
                [FieldDimensionId.Depth]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 2000 },
                    required      : true,
                    defaultValue  : 800,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardDepth, 800],
                    ],
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 100 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
            [TrayShapeId.TrayRound]: {
                [FieldDimensionId.Diameter]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 6000 },
                    required      : true,
                    defaultValue  : 1200,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardLength, 1200],
                    ],
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 100 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
            [TrayShapeId.TrayOval]: {
                [FieldDimensionId.Length]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 6000 },
                    required      : true,
                    defaultValue  : 1200,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardLength, 1200],
                    ],
                },
                [FieldDimensionId.Depth]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 100,
                    range         : { min: 500, max: 2000 },
                    required      : true,
                    defaultValue  : 800,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardDepth, 800],
                    ],
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 100 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
            [TrayShapeId.ReturnLeft]: {
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 6000 },
                    required     : true,
                    defaultValue : 1200,
                },
                [FieldDimensionId.Depth]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 2000 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.LengthReturn]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 6000 },
                    required     : true,
                    defaultValue : 1200,
                },
                [FieldDimensionId.DepthReturn]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 2000 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.ReturnRight]: {
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 6000 },
                    required     : true,
                    defaultValue : 1200,
                },
                [FieldDimensionId.Depth]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 2000 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.LengthReturn]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 300, max: 2000 },
                    required     : true,
                    defaultValue : 500,
                },
                [FieldDimensionId.DepthReturn]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 300, max: 1500 },
                    required     : true,
                    defaultValue : 500,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
        },
    },
};

export const consoleShapeDimension: IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            TrayShapeId.TrayRectangle,
            TrayShapeId.TrayOval,
            TrayShapeId.TrayArc,
        ],
        required: true,
    },
    dimension: {
        options: {
            [TrayShapeId.TrayRectangle]: {
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 2500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.Depth]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 100, max: 800 },
                    required     : true,
                    defaultValue : 250,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayOval]: {
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 2500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.Depth]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 100, max: 800 },
                    required     : true,
                    defaultValue : 250,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayArc]: {
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 2500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.Depth]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 100, max: 800 },
                    required     : true,
                    defaultValue : 250,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
        },
    },
};
